import $axios from "../api/accessor";
import { $api } from "../api/api";

export const OrdersService = {
  async getProductOrders() {
    let response = await $axios.get($api("product_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getServiceOrders() {
    let response = await $axios.get($api("service_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getInstallOrders() {
    let response = await $axios.get($api("install_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAccessoryOrders() {
    let response = await $axios.get($api("accessory_orders")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async changeProductsOrderStatus(orderId: number, statusId: number) {
    try {
      const response = await $axios.get(
        $api("change_status_products", { orderId, statusId })
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      throw error;
    }
  },
  async changeServiceOrderStatus(orderId: number, statusId: number) {
    try {
      const response = await $axios.get(
        $api("change_status_service", { orderId, statusId })
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      throw error;
    }
  },
  async changeAccessoryOrderStatus(orderId: number, statusId: number) {
    try {
      const response = await $axios.get(
        $api("change_status_accessory", { orderId, statusId })
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      throw error;
    }
  },
};
